import clsx from "clsx";

const Divider = ({ className }: { className?: string }): JSX.Element => {
  return <div className={clsx("w-full h-px bg-white/15", className)} />;
};

export default Divider;
